import api from '@/api'
import { sortBy } from 'lodash'

export default {
  namespaced: true,

  state: () => ({
    data: []
  }),

  actions: {
    get: async function (ctx, params) {
      const response = await api.get(`/v1/providers`, params)

      ctx.commit('set', response.data)
    }
  },

  mutations: {
    set: function (state, providers) {
      const data = providers.map(provider => ({
        name: provider.name,
        _id: provider._id,
        role: provider.role,
        onboarded: provider.onboarded,
        permissions: provider.permissions,
        extendLayout: provider.extendLayout
      }))
      state.data = sortBy(data, 'name')
    },

    add: function (state, provider) {
      const providers = [...state.data]

      providers.push(provider)

      state.data = sortBy(providers, 'name')
    },

    update: function (state, provider) {
      const providers = [...state.data]

      const providerIndex = providers.findIndex(u => u._id === provider._id)

      if (providerIndex >= 0) {
        providers[providerIndex] = provider
      } else {
        providers.push(provider)
      }

      state.data = sortBy(providers, 'name')
    },

    delete: function (state, provider) {
      const providers = [...state.data]

      const providerIndex = providers.findIndex(r => r._id === provider._id)

      if (providerIndex >= 0) {
        providers.splice(providerIndex, 1)
      }

      state.data = providers
    },

    reset: function (state) {
      state.data = []
    }
  }
}
